import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

const COLORS = [
  '#FF6B6B',
  '#FFD93D',
  '#6BCB77',
  '#4D96FF',
  '#FF8C42',
  '#C77DFF',
  '#FF5D8F',
  '#00C2A8',
  '#F72585',
  '#FFE66D',
  '#FF9F1C',
  '#2EC4B6',
];

const EFFECT_DURATION_MS = 5000;

const createSprinkles = (count) =>
  Array.from({ length: count }, (_, i) => {
    const shape = i % 3;
    const size = 8 + (i % 6);
    return {
      id: i,
      left: `${(i * 19 + (i % 7) * 5) % 100}%`,
      delay: `${(i % 15) * 0.25}s`,
      duration: `${3.5 + (i % 7) * 0.45}s`,
      color: COLORS[i % COLORS.length],
      width: shape === 2 ? Math.max(4, size * 0.4) : size,
      height: shape === 2 ? size * 1.6 : size,
      borderRadius: shape === 0 ? '50%' : '2px',
    };
  });

const overlayStyle = {
  pointerEvents: 'none',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100vw',
  height: '100vh',
  zIndex: 1400,
  overflow: 'hidden',
};

export default function FallingSprinkles({ count = 60 }) {
  const [active, setActive] = useState(true);
  const sprinkles = useMemo(() => createSprinkles(count), [count]);

  useEffect(() => {
    const timer = setTimeout(() => setActive(false), EFFECT_DURATION_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!active || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div data-testid="falling-sprinkles" style={overlayStyle} aria-hidden="true">
      <style>
        {`
          @keyframes vf-sprinkle-fall {
            0% {
              transform: translateY(-20px) rotate(0deg);
              opacity: 1;
            }
            100% {
              transform: translateY(105vh) rotate(720deg);
              opacity: 0.85;
            }
          }
        `}
      </style>
      {sprinkles.map((s) => (
        <span
          key={s.id}
          style={{
            position: 'absolute',
            top: '-12px',
            left: s.left,
            width: s.width,
            height: s.height,
            borderRadius: s.borderRadius,
            backgroundColor: s.color,
            animation: `vf-sprinkle-fall ${s.duration} linear ${s.delay} infinite`,
          }}
        />
      ))}
    </div>,
    document.body
  );
}
